import background from './assets/background.png';
import DSBox from '../../design-system/DSBox';
import DSAppBar from '../../design-system/DSAppBar';
import { DSTypography } from '../../design-system/Typography';
import DSPrimaryButton from '../../design-system/DSPrimaryButton';
import useGiftHomePage from './hooks/useGiftHomePage';
import { GreetSplashScreen } from './GreetSplashScreen';
import EnterClockDialog from './EnterClockDialog';
import EnterOrderDialog from './EnterOrderDialog';
import GreetLogo from './GreetLogo';
import { KLYDO_BLACK } from '../../consts/colors';
import { isMobile } from 'react-device-detect';

const GiftHomePage = () => {
  const giftHomePageResult = useGiftHomePage();

  if (giftHomePageResult.isLoading) return <GreetSplashScreen />;

  const nonLoadingResult = giftHomePageResult as Exclude<
    ReturnType<typeof useGiftHomePage>,
    { isLoading: true }
  >;
  const {
    prsonalInfo,
    handleCreateGreet,
    enterClockDialogOpen,
    handleCloseEnterClockDialog,
    handleClockConfirm,
    enterOrderNameDialogOpen,
    handleAddOrderName,
    handleCloseEnterOrderNameDialog,
    disabledCreateBasedOnGreet,
  } = nonLoadingResult;

  return (
    <div
      style={{
        backgroundImage: `url(${background})`,
        backgroundColor: KLYDO_BLACK,
        backgroundSize: isMobile ? 'cover' : 'contain',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        height: '100vh',
      }}
    >
      <DSAppBar
        onClick={() => {
          window.location.href = 'https://www.klydoclock.com/';
        }}
        color="transparent"
        sx={{
          cursor: 'pointer',
          paddingTop: isMobile ? '48px' : '40px',
          display: 'flex',
          justifyContent: 'center',
          textAlign: 'center',
          alignItems: 'center',
          boxShadow: 'none',
        }}
      >
        <GreetLogo color={KLYDO_BLACK} width={isMobile ? 150 : 250} />
      </DSAppBar>

      <DSBox
        sx={{
          position: 'absolute',
          bottom: 0,
          marginBottom: isMobile ? '34px' : '64px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
        }}
      >
        {prsonalInfo && (
          <DSTypography
            sx={{
              lineHeight: 1,
              fontFamily: 'Gilroy-Bold',
              color: '#FFFFFF',
              textAlign: 'center',
              maxWidth: { xs: '300px', md: '500px' },
              fontSize: { xs: '30px', md: '40px' },
              fontWeight: 600,
            }}
          >
            {`Hi ${prsonalInfo},`}
          </DSTypography>
        )}
        <DSTypography
          sx={{
            lineHeight: 1.2,
            fontFamily: 'Gilroy-Bold',
            color: '#FFFFFF',
            textAlign: 'center',
            mb: 2,
            maxWidth: { xs: '300px', md: '500px' },
            fontSize: { xs: '30px', md: '40px' },
            fontWeight: 600,
          }}
        >
          Welcome to KlydoGreet
        </DSTypography>
        <DSTypography
          sx={{
            fontFamily: 'Gilroy-Medium',
            color: '#FFFFFF',
            textAlign: 'center',
            mb: 3,
            maxWidth: { xs: '300px', md: '500px' },
            fontSize: { xs: '14px', md: '16px' },
          }}
        >
          Add a personal touch to your gift with your choice of animated
          greeting card and a custom note. It usually takes 5 minutes.
        </DSTypography>
        <DSPrimaryButton
          sx={{
            width: { xs: '220px', md: '240px' },
            fontSize: { xs: '14px', md: '16px' },
          }}
          disabled={!!disabledCreateBasedOnGreet}
          onClick={handleCreateGreet}
        >
          Create a KlydoGreet
        </DSPrimaryButton>

        {handleCloseEnterClockDialog && handleClockConfirm && (
          <EnterClockDialog
            open={!!enterClockDialogOpen}
            onClose={handleCloseEnterClockDialog}
            onConfirm={handleClockConfirm}
          />
        )}
        {handleCloseEnterOrderNameDialog && handleAddOrderName && (
          <EnterOrderDialog
            open={!!enterOrderNameDialogOpen}
            onClose={handleCloseEnterOrderNameDialog}
            onConfirm={handleAddOrderName}
          />
        )}
      </DSBox>
    </div>
  );
};

export default GiftHomePage;
